<template>
  <div class="wrap-image-card">
    <div>
      <img :src="imgUrl">
    </div>
  </div>
</template>

<script>
// import LightBox from 'vue-image-lightbox'
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

export default {
  props: {
    imgUrl: String
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-image-card {
  padding-bottom: 15px;

  div {

    img {
      width: 100%;
      height: 100%;
      background-color: $light;
    }
  }
}

.wrap-image-card:first-child {
  margin-top: 0;
}
</style>
